/*
 * Copyright (c) CIRROM 2026.
 */

import { rampBandColor } from "./rampColor";

/*
 * How confident Cirrom is in a proposed change - its own scale, wearing the
 * one ramp's colours.
 *
 * The bands below are calibrated to what confidence actually does, with
 * 70 as the boundary above which a suggestion is a strong indication, and
 * they are named in confidence's own language. The COLOURS remain the one
 * ramp, imported from the same single definition as the health score and the
 * deliverability markers: one colour vocabulary, per-signal calibration.
 */
export interface ConfidenceBand {
  min: number;
  label: string;
  rampBand: string;
}

export const CONFIDENCE_BANDS: ConfidenceBand[] = [
  { min: 70, label: "Strong", rampBand: "Outstanding" },
  { min: 55, label: "Moderate", rampBand: "Average" },
  { min: 35, label: "Weak", rampBand: "Poor" },
  { min: 0, label: "Very weak", rampBand: "Critical" },
];

export const getConfidenceBand = (confidence: number): ConfidenceBand =>
  CONFIDENCE_BANDS.find((band) => confidence >= band.min) ??
  CONFIDENCE_BANDS[CONFIDENCE_BANDS.length - 1];

/** Fill value, for swatches and blocks. */
export const confidenceSwatchColor = (confidence: number): string =>
  rampBandColor(getConfidenceBand(confidence).rampBand);
